export const dashboard = {
    "dashboard_title": "Dashboard",
    "dashboard_wec": "Welcome Back",
    "dashboard_loading": "Loading dashboard...",
    "dashboard_message": "Here's a quick overview of your access.",
    "dashboard_class_student_tools": "My Tools",
    "dashboard_class_my_tools": "Teacher Tools",
    "dashboard_class_management_tools": "Management Tools",
    "dashboard_class_sp_admin_tools": "Super Admin Tools",
    // User tools
    "dashboard_card_submit_hours_title": "Submit My Working Hours",
    "dashboard_card_submit_hours_desc": "Submit your working hours for approval, view your working hours.",
    "dashboard_card_shared_files_title": "Shared Teaching Files",
    "dashboard_card_shared_files_desc": "View and manage your teaching material files.",
    "dashboard_card_available_time_title": "My Available Working Time",
    "dashboard_card_available_time_desc": "View and manage your available teaching times.",
    "dashboard_card_my_papers_title": "Assessment Papers",
    "dashboard_card_my_papers_desc": "View and start your assessment papers.",
    "dashboard_card_my_class_title": "My Class",
    "dashboard_card_my_class_desc": "View your class information, members, and recent activities.",
    "dashboard_card_homeworkBank_title": "Homework Bank",
    "dashboard_card_homeworkBank_desc": "Browse and manage all assigned homeworkBank and exercises.",
    "dashboard_card_my_homework_title": "My Homework",
    "dashboard_card_my_homework_desc": "View my collection of assignments, including unfinished ones",
    "dashboard_card_grade_pending_title": "Pending Grading",
    "dashboard_card_grade_pending_desc": "View and grade homework that requires manual review.",
    // Management tools
    "dashboard_card_courses_manager_title": "Courses Manager",
    "dashboard_card_courses_manager_desc": "View and manage the available teaching times of tutors.",
    "dashboard_card_question_bank_manager_title": "Question Bank Manager",
    "dashboard_card_question_bank_manager_desc": "Manage Teacher Assessment question banks.",
    "dashboard_card_paper_manager_title": "Teacher Assessment Paper Manager",
    "dashboard_card_paper_manager_desc": "Manage Teacher Assessment papers.",
    "dashboard_card_working_manager_title": "Working Hours Manager",
    "dashboard_card_working_manager_desc": "Teaching Hours Summary Management.",
    "dashboard_card_class_manager_title": "Class Manager",
    "dashboard_card_class_manager_desc": "Manage and configure classes",

    // Super Admin
    "dashboard_card_file_log_title": "File Log",
    "dashboard_card_file_log_desc": "Teaching Material File Access Log.",
    "dashboard_card_sp_admin_manager_title": "SuperAdmin Manager",
    "dashboard_card_sp_admin_manager_desc": "Super Administrator Page."
};
